import { useState } from 'react'

const useFilePreview = () => {
  const initialThumbnails = {
    photos: [],
    videos: [],
  }
  const [previews, setPreviews] = useState<{
    photos: string[]
    videos: string[]
  }>(initialThumbnails)

  const setPreview = (res: string[], type: 'photos' | 'videos') =>
    setPreviews(prev => ({
      ...prev,
      [type]: res,
    }))

  const resetPreview = () => {
    setPreviews(initialThumbnails)
  }

  return {
    previews,
    setPreview,
    resetPreview,
  }
}

export default useFilePreview
